import { createContext, useContext, useMemo } from "react";
import api from "libs/api";

import { useQuery } from "@tanstack/react-query";

const ReferralProgramsContext = createContext();

const ReferralProgramsProvider = ({ children }) => {
  const { isLoading: loading, data } = useQuery({
    queryKey: ["referral_programs"],
    queryFn: () => api.get(`/admin/referral`),
  });

  const value = useMemo(() => {
    return {
      data,
      loading,
      init_loading: false,
    };
  }, [data, loading]);

  return (
    <ReferralProgramsContext.Provider value={value}>
      {children}
    </ReferralProgramsContext.Provider>
  );
};

const useReferralPrograms = () => useContext(ReferralProgramsContext);
export { ReferralProgramsContext, useReferralPrograms };
export default ReferralProgramsProvider;
